export default "__VITE_ASSET__ff5f521c__"